import { GET_POLICY_TERMS_ABOUT, UPDATE_TERMS_ABOUT_POLICY } from "../type";
const inital = {
  data: [],
  editData: [],
};

const termsPolicyAboutReducer = (state = inital, action) => {
  switch (action.type) {
    case GET_POLICY_TERMS_ABOUT:
      return {
        ...state,
        data: action.payload,
      };
    case UPDATE_TERMS_ABOUT_POLICY:
      return {
        ...state,
        editData: action.payload,
      };

    default:
      return state;
  }
};

export default termsPolicyAboutReducer;
